export const isCellPhone = (cellphone) => /^09\d{9}$/.test(cellphone);
export const isNotValidName = (text) => /^(?=.*[a-z]|(?=.*[A-Z])|(?=.*[0-9])).*$/.test(text);